import React, { useState, useEffect } from 'react';
import { getChatHistorybyOrgUser } from '../../utils/botFactoryAPI';

interface HistoryItem {
  [x: string]: any;
  role: string;
  transcript: string;
}

interface HistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLoad: (items: HistoryItem[]) => void;
}

// Forced to production
//const API_BASE_URL = "https://robot-api-37f87b97b291.herokuapp.com";


// Local debugging
//const API_BASE_URL = "http://localhost:10000";

const HistoryModal: React.FC<HistoryModalProps> = ({ isOpen, onClose, onLoad }) => {
  const [historyItems, setHistoryItems] = useState<HistoryItem[]>([]);

  const HISTORY_LIMIT = 5;
  const [historyOffset, setHistoryOffset] = useState(0);  
  let modal: HTMLElement | null = null;
  
  
     
    // ✅ fetch CHAT History function 
    const fetchPaginatedHistory = async (offset: number) => {

      modal = document.getElementById('history-modal');
      console.log('History Modal Opened: ', modal);

      const sessionToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('token='))
        ?.split('=')[1];

      const userOrg = JSON.parse(localStorage.getItem("user") || "null");
      const orgId = userOrg.org.orgId;
      const userId = JSON.parse(localStorage.metadata).userid || "null";

      if (!userId || !orgId || !sessionToken) {
        console.error("❌ Missing userId, orgId or token");
        return;
      }

      try {
       const response = await getChatHistorybyOrgUser(orgId, userId, sessionToken);
        if (!response) return;

        const result = response;
        setHistoryItems(result);
        onLoad?.(result);

        /*if (result && Array.isArray(result)) {
          const flattened = result.map((msg: any) => ({
            role: msg.role,
            transcript: msg.transcript
          }));

          setHistoryItems(flattened);
          onLoad?.(flattened);
        }*/
      } catch (err) {
        console.error("❌ Failed to load history:", err);
      }
    };

      
    useEffect(() => {
      if (!isOpen) return;
      if (historyItems.length > 0) return; // 🛑 Prevent loop
      //if (localStorage.getItem("history-rendered") === "true") return;

      setHistoryOffset(0);
      //localStorage.setItem("history-rendered", "true");
      fetchPaginatedHistory(historyOffset);
    }, [isOpen, historyOffset]);
    
    // Run counter
    const uniqueRunIds = Array.from(new Set(historyItems.map(item => item.runId)));

  
    if (!isOpen) return null;

    return (
      <div className="modal-overlay" id="chatHistory-modal">
        <div className="modal-container">
          {/* Header */}
          <div className="modal-header">
            <h3>Conversation History</h3>
            <button className="close-btn" id="close-btn" onClick={onClose}>&times;</button>
          </div>
 
          <div style={{ padding: "0 15px", fontSize: ".85em", color: "#444" }}>
            Conversation {historyOffset + 1}–{Math.min(historyOffset + HISTORY_LIMIT, uniqueRunIds.length)}
          </div>


          {/* Scrollable Modal Content */}
         
          {
            (() => {
              const grouped: Record<string, any[]> = {};

              // ✅ Group by runId
              for (const item of historyItems) {
                if (!grouped[item.runId]) grouped[item.runId] = [];
                grouped[item.runId].push(item);
              }

              // ✅ Sort runId groups by time DESC
              const sortedRunIds = Object.keys(grouped).sort((a, b) =>
                grouped[b][0].time < grouped[a][0].time ? -1 : 1
              );

              // ✅ Apply paging
              const pagedRunIds = sortedRunIds.slice(historyOffset, historyOffset + HISTORY_LIMIT);

              const jsx = [];

     
              for (let i = 0; i < pagedRunIds.length; i++) {
                const runId = pagedRunIds[i];
                const sessionGroup = grouped[runId];
                const session = sessionGroup[0];

                const titleSource = session.message?.[2]?.[0]?.transcript || 'Untitled';
                const title = titleSource.length > 90 ? titleSource.slice(0, 110) + '...' : titleSource;
                const timestamp = session.time;

                console.log(`📦 Render Group ${i} — RunId: ${runId}, Time: ${timestamp}`);

                let fullMessage = '';
                if (session.message.length > 2) { // Skip short sessions
                  for (let g = 0; g < session.message.length; g++) {
                    for (let m = 0; m < session.message[g].length; m++) {
                      const msg = session.message[g][m];
                      const line = msg.role + ': ' + msg.transcript;
                      fullMessage += line + '\n\n';
                    }
                  }
                }
                


                jsx.push(
                  <div key={runId} className="history-group">
                    <div style={{ color: 'gray', marginTop: '10px', padding: '10px', margin:'5px'}}>
                      {timestamp} — {runId}
                    </div>
                    <a
                      href="#"
                      className="history-link"
                      onClick={(e) => {
                        e.preventDefault();
                        console.log(`🚀 Injecting session from ${runId}`);
                
                        const input = document.getElementById('user-input') as HTMLTextAreaElement;
                        const button = document.getElementById('text-enter') as HTMLButtonElement;
                        
                      const chatHistoryModal = document.getElementById('chatHistory-modal')
                     
                        if (input) input.value = fullMessage;
                        if (chatHistoryModal) chatHistoryModal.style.display = 'none';
                        if (button) button.click();
                      }}
                    >
                     {i + 1}. {title}
                    </a>
                    <div>
                    <i
                      className="fas fa-chevron-down"
                      style={{ cursor: 'pointer', marginTop: '5px', display: 'inline-block' }}
                      onClick={() => {
                        const section = document.getElementById(`details-${runId}`);
                        const icon = document.getElementById(`icon-${runId}`);
                        if (section && icon) {
                          const isVisible = section.style.display === 'block';
                          section.style.display = isVisible ? 'none' : 'block';
                          icon.className = isVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up';
                        }
                      }}
                      id={`icon-${runId}`}
                    ></i>
                  </div>
                  <div
                    id={`details-${runId}`}
                    style={{ display: 'none', padding: '10px 0' }}
                  >
                    <pre style={{ padding: '5px', margin: '3px', fontSize: '8pt', whiteSpace: 'pre-wrap', maxHeight: '20vh', overflow: 'scroll'}}>
                    {sessionGroup
                      .flatMap(s =>
                        Array.isArray(s.message)
                          ? s.message.flatMap((g: any[]) =>
                              Array.isArray(g)
                                ? g
                                    .filter(msg => msg.transcript && msg.role)
                                    .map((msg: any) => `${msg.role}: ${msg.transcript}`)
                                : []
                            )
                          : []
                      )
                      .join('\n\n')}
                    </pre>
                  </div>
                  </div>
                );
              }

              return jsx;
            })()
          }



          {/* Footer with Navigation */}
          <button
            className="prev-btn"
            onClick={() => {
              localStorage.removeItem("history-rendered");
              const newOffset = Math.max(historyOffset - HISTORY_LIMIT, 0);
              setHistoryOffset(newOffset);
            }}
            disabled={historyOffset === 0}
          >
            Previous
          </button>
          <button
            className="next-btn"
            onClick={() => {
              localStorage.removeItem("history-rendered");
              setHistoryOffset(historyOffset + HISTORY_LIMIT);
            }}
          >
            Next
          </button>

          </div>

        </div>
      
    );};

// CSS Styling
const style = document.createElement('style');
style.textContent = `
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    max-height : 80vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    overflow-y:scroll;
  }

  .modal-container {
    background: white;
    width: 65vw;
    max-width: 90%;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 10px #551540;
    border: 2px solid #551540;
  }
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background: #551540;
    color: white;
    font-size: 1.2em;
  }

  .modal-content {
    max-height: 35vh;
    overflow-y: auto;
    padding: 15px;
    background: #f8f8f8;
  }

  .history-item {
    padding: 10px 0;
    border-bottom: 1px solid #ddd;
  }

  .history-item a {
    text-decoration: none;
    color: #007BFF;
  }

`;
document.head.appendChild(style);
  
export default HistoryModal;
